import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=c8a7cb9c&scoped=true&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=c8a7cb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a7cb9c",
  null
  
)

component.options.__file = "AppSidebar.vue"
export default component.exports